import React from 'react';
import { useCreatePersonForm } from './CreatePersonForm';
import { Button, ButtonColor, ButtonSize, IconType } from 'ui-builder';

export default function CreateContactButton() {
  const form = useCreatePersonForm();

  return (
    <Button
      text="Add contact"
      onClick={() => form.open()}
      size={ButtonSize.MEDIUM}
      isFilled
      color={ButtonColor.BLUE}
      iconType={IconType.PLUS}
    />
  );
}
